import { useSpring } from 'react-spring';

interface IArgs {
    stage: string;
    delay?: number;
    onRest?(): void;
}

export function createFadeInOutAnimation(config: IArgs) {
    const { stage, delay, onRest } = config;

    return useSpring({
        from: {
            opacity: stage === 'enter' ? 0 : 1,
        },
        to: {
            opacity: stage === 'exit' ? 0 : 1,
        },
        delay,
        onRest,
    });
}
